import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { FieldRegistration } from 'views/fish-check/types/field-collection.type';

import Paper from 'components/paper';
import { Grid, Typography } from '@mui/material';

type Props = {
  fishCheck: FieldRegistration;
};

const PAGE_ID = 'fishCheck.header';

const FishCheckHeader: React.FC<Props> = ({ fishCheck }) => {
  return (
    <Paper marginBottom={4}>
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="caption">
            <FormattedMessage id={`${PAGE_ID}.siteNameLabel`} />
          </Typography>
          <Typography>{fishCheck.siteName ?? <FormattedMessage id="general.notApplicable" />}</Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="caption">
            <FormattedMessage id={`${PAGE_ID}.dateCreatedLabel`} />
          </Typography>
          <Typography>
            <FormattedDate value={fishCheck.dateCreated} day="2-digit" month="short" year="numeric" />
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="caption">
            <FormattedMessage id={`${PAGE_ID}.dateLastUpdatedLabel`} />
          </Typography>
          <Typography>
            <FormattedDate value={fishCheck.dateLastUpdated} day="2-digit" month="short" year="numeric" />
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default React.memo(FishCheckHeader);
